import React, { useState, useEffect, useContext, createContext } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';

export const selectedMissionContext = createContext();

function NetPriceModal(props) {

  const { api, showModal, toggleModal, title, table, selectedIndex, selectedTab, refreshData, data } = props;
  const { tabData, setCart } = useContext(PosCartContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const { settingData } = useContext(DataContext);


  const cart = tabData[selectedTab].cart;


  useEffect(() => {
    setInputValue("");
  }, [showModal]);


  const handleSubmit = () => {

    let updatedCart = [...cart]; 
    const item = updatedCart[selectedIndex];
    
    updatedCart[selectedIndex] = {
      ...updatedCart[selectedIndex], 
          netPrice: inputValue || item.price,
          itemPrice: (inputValue || item.price) / item.unitQuantity,
          priceDiscountPercentage: item.price > 0 ? ((1 - (inputValue || item.price) / item.price) * 100) : 0,
          totalPrice: inputValue*(item.netQuantity),
          vatAmount: parseFloat((inputValue || item.price) * item.vatPercentage / 100)
      }
    setCart(updatedCart, selectedTab);
    toggleModal();
  }

  return (
    <Modal show={showModal} onHide={toggleModal} className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }} closeButton>
        <Modal.Title className="arabicText" style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">

        <Row className="mb-4">
          <Col>
            <Form.Control type='number' value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { handleSubmit() }}}
              autoFocus />
          </Col>
        </Row>

        <Row>
          <Col md={2}>
          </Col>
          <Col md={8}>
            <KeyPad
              setInputValue={setInputValue}
              inputValue={inputValue}
            />
          </Col>
          <Col md={2}>
          </Col>
        </Row>

      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={handleSubmit}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default NetPriceModal;
